module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace_v3.c6892b8aaeceece58b90dce0fa6e9936.png";